export const LOGO = "/images/age-logo.png";

export const HERO = {
  titleLead: "10./15. výročí založení",
  titleAccent: "AGE Centra",
  subtitle: "Krok za krokem k duševnímu zdraví.",
  date: "4. září 2026",
  time: "14:30",
  location: "Sokolská 7, Olomouc",
  image: "/images/building.png",
  imageAlt: "Vstup do budovy Sokolská 7, Olomouc",
};

export const ABOUT = {
  eyebrow: "Pozvánka",
  parts: [
    { text: "Vážení přátelé, kolegové, pacienti i pečující, dne " },
    { text: "4. září 2026", hl: true },
    { text: " Vás srdečně zveme na " },
    { text: "Malou kulturní scénu Sedmička, Sokolská 7 v Olomouci", hl: true },
    {
      text:
        ", kde společně oslavíme 10./15. výročí od založení AGE Centra. Připravili jsme pro Vás bohatý program, který propojuje odborná témata s příjemným společenským odpolednem. Těšíme se na Vás!",
    },
  ],
};

export const PANEL = {
  eyebrow: "Hlavní program",
  title: "Panelová diskuze",
  description:
    "aneb co podle vašeho názoru chybí v systému současné zdravotně-sociální péče.",
  hosts: [
    {
      name: "Mgr. et Mgr. Marek „Orko“ Vácha, Ph.D.",
      role: "Host panelu",
      bio: "Mgr. et Mgr. Marek „Orko“ Vácha, Ph.D., je uznávaný bioetik, molekulární biolog, teolog a římskokatolický kněz, který patří k nejvýraznějším osobnostem současného českého veřejného života. Dlouhodobě se věnuje morálním a humánním aspektům medicíny, přičemž ve své činnosti jedinečným způsobem kombinuje hluboké vědecké vzdělání s duchovní službou.",
      image: "/images/vacha.png",
    },
    {
      name: "MUDr. Simona Papežová",
      role: "Host panelu",
      bio: "MUDr. Simona Papežová je členkou Psychiatrické společnosti ČLS JEP a dlouhodobě je páteří reformy psychiatrické péče v České republice. Ve své klinické praxi se systematicky zaměřuje na rozvoj, modernizaci a rozšiřování kvality i dostupnosti péče o duševní zdraví pro české pacienty.",
      image: "/images/papezova.png",
    },
    {
      name: "Bc. Kateřina Dobrozemská",
      role: "Host panelu",
      bio: "Bc. Kateřina Dobrozemská působí jako náměstkyně primátorky města Olomouce pro sociální oblast a má za sebou bohaté zkušenosti jako manažerka sociálních služeb. Ve své profesní a politické roli se zaměřuje na rozvoj regionální sociální sítě, podporu zranitelných skupin a efektivní řízení pomoci.",
      image: "/images/dobrozemska.png",
    },
    {
      name: "Mgr. Bc. Tomáš Hégr",
      role: "Host panelu",
      bio: "Mgr. Bc. Tomáš Hégr je pokračovatelem dlouholeté tradice lékárenských služeb v Olomouci. Úspěšně zde provozuje síť lékáren, včetně známé Lékárny U Pöttingea. Ve své praxi se zaměřuje na zajišťování špičkové farmaceutické péče, odborné poradenství a lékovou bezpečnost pro širokou veřejnost. Dlouhodobě spolupracuje s AGE Centrem při zajišťování komplexních zdravotních služeb.",
      image: "/images/hegr.png",
    },
    {
      name: "MUDr. Dagmar Malotová, MBA",
      role: "Pořadatel / Host panelu",
      tag: "Za AGE Centrum",
      bio: "MUDr. Dagmar Malotová, MBA je spoluzakladatelkou a medicínskou ředitelkou AGE Centra a zároveň uznávanou odbornicí na medicínu dlouhodobé péče a geriatrii. Ve své klinické i manažerské praxi se zaměřuje na rozvoj Ambulancí s rozšířenou péčí a systematické zvyšování kvality i bezpečnosti komplexních zdravotních služeb.",
      image: "/images/malotova.png",
    },
  ],
};

export const SCHEDULE = {
  eyebrow: "Program dne",
  title: "Harmonogram & doprovodný program",
  events: [
    { time: "14:30", description: "Otevření areálu" },
    { time: "16:30", description: "Zahájení odborného programu a panelové diskuze" },
  ],
  extraTitle: "Doprovodný program",
  extras: [
    { icon: "Sparkles", text: "Informační stánky věnované péči o duševní zdraví" },
    { icon: "Music", text: "Aktivity pro návštěvníky všech věkových kategorií" },
    { icon: "Coffee", text: "Výběrová káva a občerstvení kavárny Pikola" },
  ],
};

export const TICKET = {
  title: "Naskenujte QR kód pro nákup vstupenky na panelovou diskuzi.",
  note: "Výtěžek z prodeje vstupenek bude věnován na dobročinné účely.",
  qr: "/images/panel-qr.png",
};

export const FOOTER = {
  tagline: "Pečujeme s láskou!",
  website: "www.agecentrum.cz",
  email: "info@agecentrum.cz",
  phone: "+420 603 339 339",
  address: "Na Šibeníku 914/1, Olomouc",
  copyright: "© 2026 AGE Centrum · 15. výročí založení · Olomouc",
};

export const NAV = [
  { label: "Pozvánka", href: "#pozvanka" },
  { label: "Panel", href: "#panel" },
  { label: "Program", href: "#program" },
  { label: "Kontakt", href: "#kontakt" },
];
